"use client";

import { useEffect } from "react";
import { useAppStore, User, Server } from "@/store/app-store";

interface AppProviderProps {
  children: React.ReactNode;
  initialUser: User | null;
  initialServers: Server[];
}

export function AppProvider({ children, initialUser, initialServers }: AppProviderProps) {
  const { 
    setUser, 
    setServers, 
    setActiveServerId,
  } = useAppStore();

  useEffect(() => {
    if (initialUser) {
      setUser(initialUser);
    }
    
    if (initialServers && initialServers.length > 0) {
      setServers(initialServers);
      setActiveServerId(initialServers[0].id);
    }
  }, [initialUser, initialServers, setUser, setServers, setActiveServerId]);

  return <>{children}</>;
}
